import { render, staticRenderFns } from "./AccessGroupEditor.vue?vue&type=template&id=e6d03d46&"
import script from "./AccessGroupEditor.vue?vue&type=script&lang=js&"
export * from "./AccessGroupEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports